<template lang="html">
  <div id="editingPopup" v-if="$store.state.editingState.isPopupShown">
    <span>予約の編集</span><br>
    <a>現在の教室:{{ $store.state.editingState.classroom }}</a><br>
    <button @click="changeClassroomLeft()">教室を左に移動</button>
    <button @click="changeClassroomRight()">教室を右に移動</button>
    <form
    id="editingForm"
    @mousedown.stop
    @mouseup.stop
    @mousemove.stop
    >
    <table
      :class="{errorDuplication: isSomeDuplicatedReservation}"
      :title="isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : ''">
      <tr>
        <td><span>時間: </span></td>
        <td>
          <input type="time" min="10:00" max="23:00" class="time_Selector" v-model="$store.state.editingState.start">
          </td>〜
          <td>
          <input type="time" min="10:00" max="23:00" class="time_Selector" v-model="$store.state.editingState.end">
            </td>
        </tr>
        </table>

        <div>
          <label id="reservationType">授業の種類：
            <label id="reservationType">授業の種類：
              <select name="example" v-model="reservationType">
                <option>通常</option>
                <option>通常初回</option>
                <option>体験</option>
                <option>短期</option>
                <option>短期初回</option>
              </select>
              授業
          </label>
        </label>
        </div>          <div>
            <template v-if="!isTanki">
              <div>
                <span>生徒のお名前：</span>
                <template v-if="$store.state.userInfo.user_type === 'student'">
                  <input type="text" :value="$store.state.userInfo.fullname" readonly />
                  <input type="text" hidden :value="setHiddenID()" />
                </template>
                <template v-else-if="$store.state.userInfo.user_type === 'teacher'"><!-- teacherの時 -->
                  <autocomplete v-model="student" :suggestions="getStudentList()" :type="'student'" :placeholder="'生徒のお名前'"></autocomplete>
                </template>
                <template v-else><!-- admin の場合-->
                  <autocomplete v-model="student" :suggestions="getStudentList()" :type="'admin'"
                  :placeholder="'生徒のお名前'"></autocomplete>
                </template>
              </div>
              <span>先生のお名前：</span>
              <template v-if="$store.state.userInfo.user_type === 'teacher'">
                <input type="text" :value="$store.state.userInfo.fullname" readonly />
                <input type="text" hidden :value="setHiddenID()" />
              </template>
              <template v-else-if="$store.state.userInfo.user_type === 'student'">
                <autocomplete v-model="teacher" :suggestions="getTeacherList()" :type="'teacher'" :placeholder="'先生のお名前'"></autocomplete>
              </template>
              <template v-else>
                <autocomplete v-model="teacher" :suggestions="getTeacherList()" :type="'admin'" :placeholder="'先生のお名前'"></autocomplete>
              </template>
            </template>
          </div>
          <template v-if="!isTanki">
            <recurrent-panel v-if="isRecurrent"></recurrent-panel>

            <div>
              <label id="hasTest">配布物（確認テスト等）
                <select v-model="hasTest">
                  <option :value="true">
                    有り
                  </option>
                  <option :value="false">
                    無し
                  </option>
                </select>
              </label>
              </div>
              <input type="checkbox" :checked="isOnline()"  
              @change="$store.commit('EDITINGSTATE_SET_IS_ONLINE', !isOnline())"> オンライン授業</input>
              <textarea id="message" :value="message()"
              @input="$store.commit('EDITINGSTATE_SET_MESSAGE', $event.target.value)" placeholder="連絡事項"></textarea>

              <div v-if="false">
                <label>
                  <input type="checkbox" v-model="isAllEditing" />
                  以降の予約全てを変更する
                </label>
              </div>
              <div class="ender">
                <input type="button" @click="completeEdit" value="編集を完了する"
                :disabled="!canTakeResv"/>
                <input id="eraseButton" type="button" @click="eraseReservation" value="予約を削除する" />
                <input type="button" @click="closePopup" value="キャンセル"/>
              </div>
            </template>
            <template v-if="isTanki">
              <temporaryLecturePanel :teacher="teacher" :isEdit="true" :reservationType="reservationType">
                <span>先生のお名前：</span>
                <template v-if="$store.state.userInfo.user_type === 'teacher'">
                  <input type="text" :value="$store.state.userInfo.fullname" readonly />
                  <input type="text" hidden :value="setHiddenID()" />
                </template>
                <template v-else-if="$store.state.userInfo.user_type === 'student'">
                  <autocomplete v-model="teacher" :suggestions="getTeacherList()" :type="'teacher'" :placeholder="'先生のお名前'"></autocomplete>
                </template>
                <template v-else>
                  <autocomplete v-model="teacher" :suggestions="getTeacherList()" :type="'admin'" :placeholder="'先生のお名前'"></autocomplete>
                </template>
              </temporaryLecturePanel>
            </template>
          </form>
          <!-- 確認ダイアログ -->
          <el-dialog
            class="dialog"
            title="変更の確認"
            :visible.sync="dialogEditVisible"
            width="80%"
            :modal-append-to-body="false"
            top="30%">
            <p>この予約は月末まで毎週予約されています。</p>
            <p>以降の予約を全て変更しますか？この予約のみを変更しますか？</p>
            <span slot="footer" class="dialog-footer">
              <el-button
                @click="() => {
                  isAllEditing=true
                  dialogEditVisible=false
                  doEdit()
                }">
                以降の予約全てを変更
              </el-button>
              <el-button type="primary"
              @click="() => {
                isAllEditing=false
                dialogEditVisible=false
                doEdit()
              }">
                この予約のみ変更
              </el-button>
            </span>
          </el-dialog>
          <el-dialog
            class="dialog"
            title="削除の確認"
            :visible.sync="dialogDeleteVisible"
            width="80%"
            :modal-append-to-body="false"
            top="30%">
            <p>この予約は月末まで毎週予約されています。</p>
            <p>以降の予約を全て削除しますか？この予約のみを削除しますか？</p>
            <span slot="footer" class="dialog-footer">
              <el-button
                @click="() => {
                  isAllEditing=true
                  dialogDeleteVisible=false
                  doDelete()
                }">
                以降の予約全てを削除
              </el-button>
              <el-button type="primary"
              @click="() => {
                isAllEditing=false
                dialogDeleteVisible=false
                doDelete()
              }">
                この予約のみ削除
              </el-button>
            </span>
          </el-dialog>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  EDITINGBOX_TIME_UPDATE,
  EDITINGBOX_CLASSROOM_UPDATE,
  EDITINGSTATE_SET_STUDENT,
  EDITINGSTATE_SET_TEACHER,
  EDITINGSTATE_SET_HAS_TEST,
  EDITINGSTATE_SET_IS_ONLINE,
  RESERVATIONBOX_FINISH_EDIT,
  EDITING_POPUP_HIDE,
  SPINNER_HIDE,
  SPINNER_SHOW
} from '@/vuex/mutation_types'
import RecurrentReservePanel from './SpRecurrentReservePanel'
import AutocompleteSelection from './SpAutocompleteSelection'
import { TimeSelect } from 'element-ui'
import TemporaryLecturePanel from './SpTemporaryLecturePanel'
export default {
  data () {
    return {
      width: 450,
      isAllEditing: false,
      dialogEditVisible: false,
      dialogDeleteVisible: false,
      formatstarttime: null,
      formatendtime: null
    }
  },
  components: {
    'recurrent-panel': RecurrentReservePanel,
    'time-select': TimeSelect,
    'autocomplete': AutocompleteSelection,
    'temporaryLecturePanel': TemporaryLecturePanel
  },
  methods: {
    ...mapActions([
      'getReservations',
      'editReservation',
      'deleteReservation',
      'updateUserList',
      'postRecurrentReservations',
      'editRecurrentReservations',
      'deleteRecurrentReservations'
    ]),
    updateStartTime (val) {
      this.$store.commit(EDITINGBOX_TIME_UPDATE,
        { start: val }
      )
    },
    updateEndTime (val) {
      this.$store.commit(EDITINGBOX_TIME_UPDATE,
        { end: val }
      )
    },
    doEdit () {
      let rType = this.reservationType
      /*
      if (rType === '短期') {
        rType = '通常'
      }
      if (rType === '短期初回') {
        rType = '通常初回'
      } */
      this.$store.commit(SPINNER_SHOW)
      if (!this.isAllEditing) {  // 1予約の編集
        this.editReservation(
          { id: this.$store.state.editingState.id,
            reservation: {
              student: this.student,
              teacher: this.teacher,
              start_time: this.$store.state.editingState.start,
              end_time: this.$store.state.editingState.end,
              classroom: this.$store.state.editingState.classroom,
              date: this.getCurDateFormated,
              has_test: this.hasTest,
              reservation_type: rType,
              message: this.$store.state.editingState.message,
              online: this.$store.state.editingState.online
            }
          }).then(() => {
            this.closePopup()
            // 予約情報を更新
            this.getReservations({
              all: 1,
              date: this.getCurDateFormated,
              school_id: this.$store.state.userInfo.school_id
            })
            this.$store.commit(RESERVATIONBOX_FINISH_EDIT)
            this.$store.commit(SPINNER_HIDE)
          })
        return
      } else if (this.isAllEditing) { // 繰り返し予約において以降の予約を全て変更
        this.editRecurrentReservations({
          id: this.$store.state.editingState.recurrence_id,
          reservation: {
            student: this.student,
            teacher: this.teacher,
            start_time: this.$store.state.editingState.start,
            end_time: this.$store.state.editingState.end,
            classroom: this.$store.state.editingState.classroom,
            rrule: this.$store.state.recurrentRule,
            has_test: this.hasTest,
            reservation_type: rType,
            message: this.$store.state.editingState.message,
            from_reservaiton_id: this.$store.state.editingState.id,
            online: this.$store.state.editingState.online
          }
        }).then((res) => {
          if (res.data.overlapping_datetimes.length !== 0) {
            let message = '次の日付は，重複のため予約に失敗しました．'
            for (let dates of res.data.overlapping_datetimes) {
              message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + ')'
            }
            alert(message)
          }
          this.closePopup()
          // 予約情報を更新
          this.getReservations({
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
          this.$store.commit(RESERVATIONBOX_FINISH_EDIT)
          this.$store.commit(SPINNER_HIDE)
        })
      } else {  // もともと繰り返しではなかった予約を，繰り返し予約に変更する
        this.deleteReservation(this.$store.state.editingState.id)
        .then(() => {
          // 改めて，繰り返し予約として予約する
          this.postRecurrentReservations({
            student: this.student,
            teacher: this.teacher,
            start_time: this.$store.state.editingState.start,
            end_time: this.$store.state.editingState.end,
            classroom: this.$store.state.editingState.classroom,
            rrule: this.$store.state.recurrentRule,
            has_test: this.hasTest,
            reservation_type: rType,
            message: this.$store.state.editingState.message,
            online: this.$store.state.editingState.online
          }).then((res) => {
            if (res.data.overlapping_datetimes.length !== 0) {
              let message = '次の日付は，重複のため予約に失敗しました．'
              for (let dates of res.data.overlapping_datetimes) {
                message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + '), '
              }
              alert(message)
            }
            this.closePopup()
            // 予約情報を更新
            this.getReservations({
              date: this.getCurDateFormated,
              school_id: this.$store.state.userInfo.school_id
            })
            this.$store.commit(RESERVATIONBOX_FINISH_EDIT)
            this.$store.commit(SPINNER_HIDE)
          })
        })
      }
    },
    completeEdit () {
      // 空欄チェック
      if (this.student === 0 || this.teacher === 0) {
        alert('空欄では予約できません')
        return
      }
      // 予約時間帯のチェック
      if (this.$store.state.editingState.start < '10:00' || this.$store.state.editingState.end > '23:00' || this.$store.state.editingState.end < this.$store.state.editingState.start) {
        alert('予約時間帯のチェック')
        return
      }
      // 教室の仕様変更のため307は15時以降の予約を禁止
      if (this.$store.state.editingState.classroom.match('307')) {
        if (this.$store.state.editingState.start < '15:00' && this.$store.state.userInfo.user_type !== 'admin') {
          alert('15時以前307教室は使用できません')
          return
        }
      }

      if (this.isRecurrent) {
        this.dialogEditVisible = true
      } else {
        this.doEdit()
      }
    },
    doDelete () {
      this.$store.commit(SPINNER_SHOW)
      if (!this.isAllEditing) { // 1予約のみ削除
        this.deleteReservation(this.$store.state.editingState.id)
        .then(() => {
          // 予約情報を更新
          this.getReservations({
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
      } else {  // 以降の予約全て削除
        this.deleteRecurrentReservations({id: this.$store.state.editingState.recurrence_id, fromReservaitonId: this.$store.state.editingState.id})
        .then(() => {
          // 予約情報を更新
          this.getReservations({
            all: 1,
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
      }
    },
    eraseReservation () {
      if (this.isRecurrent) {
        this.dialogDeleteVisible = true
      } else {
        let ret = confirm('削除します．よろしいですか？')
        if (ret) {
          this.doDelete()
        }
      }
    },
    closePopup () {
      // popupを閉じる
      this.$store.commit(EDITING_POPUP_HIDE)
      // preview box を閉じる
      this.$store.commit(EDITINGBOX_TIME_UPDATE,
        {
          start: '10:00',
          end: '10:00'
        }
      )
      this.$store.commit(RESERVATIONBOX_FINISH_EDIT)
    },
    setHiddenID () {
      if (this.$store.state.userInfo.user_type === 'student') {
        this.student = this.$store.state.userInfo.user_id
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        this.teacher = this.$store.state.userInfo.user_id
      }
      return this.$store.state.userInfo.user_id
    },
    changeClassroomLeft () {
      let index =
        this.classroomNames.indexOf(this.$store.state.editingState.classroom)
      if (index > 0) {
        this.$store.commit(EDITINGBOX_CLASSROOM_UPDATE, this.classroomNames[index - 1])
      }
    },
    changeClassroomRight () {
      let index =
        this.classroomNames.indexOf(this.$store.state.editingState.classroom)
      if (index < this.classroomNames.length - 1) {
        this.$store.commit(EDITINGBOX_CLASSROOM_UPDATE, this.classroomNames[index + 1])
      }
    },
    getStyle () {
      let style = {
        width: this.width + 'px'
      }
      return style
    },
    message () {
      return this.$store.state.editingState.message
    },
    isOnline () {
      console.log(this.$store.state.editingState.online)
      return this.$store.state.editingState.online
    },
    getTeacherList () {
      // すでに生徒を選んでいる場合
      if (this.student !== 0) {
        return this.$store.state.lectureInfo.filter((lect, index, self) => {
          return this.student === lect.student.id
        }).map((lect, index, self) => {
          return lect.teacher
        })
      }
      // それ以外の場合，教師全体のリストを返す
      if (this.$store.state.userlist.length === 0) {
        this.updateUserList()
      }
      return this.$store.state.userlist.filter((user, index, self) => {
        return user.user_type === 'teacher'
      })
    },
    getStudentList () {
      // すでに教師を選んでいる場合
      if (this.teacher !== 0) {
        return this.$store.state.lectureInfo.filter((lect, index, self) => {
          // 応急処置として短期ユーザも常に表示するように
          // return this.teacher === lect.teacher.id && !/^tanki_/.test(lect.student.user_name)
          return this.teacher === lect.teacher.id
        }).map((lect, index, self) => {
          return lect.student
        })
      }
      // それ以外の場合，生徒全体のリストを返す
      if (this.$store.state.userlist.length === 0) {
        this.updateUserList()
      }
      return this.$store.state.userlist.filter((user, index, self) => {
        // 応急処置として初回の場合は短期ユーザを表示するように
        return user.user_type === 'student' && !(this.reservationType === '通常' && (/temp/.test(user.user_status) || user.user_status === 'trial'))
        // return user.user_type === 'student' && !(this.reservationType === '通常' && /^tanki_/.test(user.user_name))
      })
    }
  },
  computed: {
    ...mapGetters([
      'tableWidth',
      'timelineHeight',
      'getCurDateFormated',
      'classroomNames',
      'reservationsInRange'
    ]),
    canTakeResv () { // 予約するボタンの disable 属性の可否
      // 教師か生徒が未選択
      if (this.teacher === 0 || this.student === 0) {
        return false
      }
      // 同時間帯の重複の有無
      if (this.isSomeDuplicatedReservation) {
        return false
      }
      return true
    },
    isRecurrent: {
      get () {
        return this.$store.state.editingState.isRecurrent
      }
    },
    student: {
      get () {
        return this.$store.state.editingState.student
      },
      set (value) {
        this.$store.commit(EDITINGSTATE_SET_STUDENT, value)
      }
    },
    teacher: {
      get () {
        return this.$store.state.editingState.teacher
      },
      set (value) {
        this.$store.commit(EDITINGSTATE_SET_TEACHER, value)
      }
    },
    hasTest: {
      get () {
        return this.$store.state.editingState.hasTest
      },
      set (value) {
        this.$store.commit(EDITINGSTATE_SET_HAS_TEST, value)
      }
    },
    isTanki: {
      get () {
        return this.$store.state.editingState.reservationType !== '通常' &&
               this.$store.state.editingState.reservationType !== '通常初回' &&
               this.$store.state.editingState.reservationType !== '短期'
      },
      set (value) {
        this.$store.commit('EDITINGSTATE_SET_TYPE', value)
      }
    },
    reservationType: {
      get () {
        return this.$store.state.editingState.reservationType
      },
      set (value) {
        this.$store.commit('EDITINGSTATE_SET_TYPE', value)
      }
    },
    online: {
      get () {
        return this.$store.state.editingState.online === 'true'
      },
      set (value) {
        this.$store.commit(EDITINGSTATE_SET_IS_ONLINE, value)
      }
    },
    isSomeDuplicatedReservation () {
      return this.reservationsInRange(
        this.$store.state.editingState.start,
        this.$store.state.editingState.end
      ).filter((elem, index, self) => {
        // 編集の場合，元の予約を除外
        return elem.id !== this.$store.state.editingState.id
      }).some((elem, index, self) => {
        return (elem.teacher.id === this.$store.state.editingState.teacher ||
        elem.student.id === this.$store.state.editingState.student)
      })
    }
  }
}
</script>

<style lang="css" scoped>
#editingPopup {
  position: absolute;
  top: 81px;
  width: 100%;
  height: 90vh;
  left: -5px;
  right: 0;
  font-size: 5vw;
  margin: 0px 5px 0px;
  box-sizing: border-box;
  background-color: white;
  border-color: #0065B3;
  border-style: solid;
  border-radius: 5px;
  padding-top: 5px;
  z-index: 1005;
}
#message {
  width: 90%;
}
#editingForm {
  text-align: left;
  padding: 10px 10px 5px 10px;
  margin: auto;
}
#eraseButton {
  color: #ff6666;
}
.closeButton {
  float: right;
  border: none;
  color: white;
  margin-right: 5px;
  background-color: #ffd500;
}
.closeButton:hover {
  opacity: 0.5;
}
.errorDuplication { /* 同一ユーザーの同一時間での予約の重複がある */
  background-color: #ffcccc;
}
.dialog {
  text-align: left;
}
.time_Selector{
  width: 30vw;
}
.ender{
  text-align: center;
  margin: auto;
}
.ender input{
  margin: 2vw;
  font-size: 5vh;
  border-radius: 5px;
}
.ender button{
  margin: 2vw;
  font-size: 10vw;
  border-radius: 5px;
}
button{
  font-size: 5vw;
}
</style>



// WEBPACK FOOTER //
// SpEditingPopup.vue?de800e5a